// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAwmnt } from "../../../icons/mono/build/icon-awmnt.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AwmntIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAwmnt.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AwmntIcon.displayName = 'AwmntIcon';
}

export default AwmntIcon;